(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uav-categories"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = (root = document) => {
      root.querySelectorAll('[data-uav-category-browser]').forEach(details => {
        if (details.dataset.ready) return;
        details.dataset.ready = 'true';
        const wide = matchMedia('(min-width: 700px)');
        details.open = wide.matches;
        wide.addEventListener('change', event => { if (details.isConnected) details.open = event.matches; });
      });
    };
    initialise();
    document.addEventListener('shopify:section:load', event => initialise(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uav-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uav-product-gallery')) {
    customElements.define('uav-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.resize?.observe(this.viewport); return; }
        this.initialized = true;
        this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
        this.index = Math.max(0, this.thumbs.findIndex(button => button.getAttribute('aria-current') === 'true'));
        this.dialog = this.querySelector('dialog');
        this.viewport = this.querySelector('.uav-gallery__viewport');
        this.canvas = this.querySelector('.uav-gallery__canvas');
        this.large = this.querySelector('.uav-gallery__large');
        this.zoom = 1;
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-gallery-thumb]');
          if (thumb) this.select(Number(thumb.dataset.index));
          if (event.target.closest('[data-gallery-open]')) this.open();
          if (event.target.closest('[data-gallery-close]')) this.dialog.close();
          if (event.target.closest('[data-gallery-prev]')) this.select(this.index - 1);
          if (event.target.closest('[data-gallery-next]')) this.select(this.index + 1);
          if (event.target.closest('[data-gallery-in]')) this.setZoom(this.zoom + 0.5);
          if (event.target.closest('[data-gallery-out]')) this.setZoom(this.zoom - 0.5);
          if (event.target.closest('[data-gallery-reset]')) this.setZoom(1);
        });
        this.dialog.addEventListener('close', () => this.restore());
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
        this.addEventListener('keydown', event => {
          if (this.dialog.open) {
            if (event.key === 'ArrowLeft' && this.zoom === 1) { event.preventDefault(); this.select(this.index - 1); }
            if (event.key === 'ArrowRight' && this.zoom === 1) { event.preventDefault(); this.select(this.index + 1); }
            if (event.key === '+' || event.key === '=') { event.preventDefault(); this.setZoom(this.zoom + .5); }
            if (event.key === '-') { event.preventDefault(); this.setZoom(this.zoom - .5); }
            if (event.key === '0') { event.preventDefault(); this.setZoom(1); }
          } else if (event.target.matches('[data-gallery-thumb]')) {
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault(); this.select(Number(event.target.dataset.index) + (event.key === 'ArrowRight' ? 1 : -1)); this.thumbs[this.index].focus();
            }
          }
        });
        this.viewport.addEventListener('pointerdown', event => {
          if (this.zoom <= 1 || event.pointerType === 'touch' || event.button !== 0) return;
          this.drag = {x:event.clientX,y:event.clientY,left:this.viewport.scrollLeft,top:this.viewport.scrollTop,id:event.pointerId};
          this.viewport.setPointerCapture(event.pointerId); this.viewport.dataset.dragging = 'true'; event.preventDefault();
        });
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag) return;
          this.viewport.scrollLeft = this.drag.left - event.clientX + this.drag.x;
          this.viewport.scrollTop = this.drag.top - event.clientY + this.drag.y;
        });
        const endDrag = () => { this.drag = null; this.viewport.dataset.dragging = 'false'; };
        this.viewport.addEventListener('pointerup', endDrag);
        this.viewport.addEventListener('pointercancel', endDrag);
        this.viewport.addEventListener('lostpointercapture', endDrag);
        this.resize = new ResizeObserver(() => { if (this.dialog.open) this.setZoom(this.zoom); });
        this.resize.observe(this.viewport);
      }
      disconnectedCallback() { this.resize?.disconnect(); if (this.dialog?.open) { this.dialog.close(); this.restore(); } }
      select(index) {
        if (!this.thumbs.length) return;
        this.index = (index + this.thumbs.length) % this.thumbs.length;
        const selected = this.thumbs[this.index];
        this.thumbs.forEach((button, i) => i === this.index ? button.setAttribute('aria-current','true') : button.removeAttribute('aria-current'));
        const main = this.querySelector('.uav-gallery__image');
        main.removeAttribute('srcset'); main.src = selected.dataset.src; main.alt = selected.dataset.alt;
        this.dataset.view = selected.dataset.view || 'standard';
        // Each thumbnail carries its own measured fill (see uav-image-fill), so
        // a rear-panel view never inherits the lead image's scale.
        (selected.dataset.fill || '').split(';').forEach(pair => {
          const [name, value] = pair.split(':');
          if (name && value) this.style.setProperty(name.trim(), value.trim());
        });
        if (this.dialog.open) this.updateViewer();
      }
      open() {
        if (!this.thumbs.length || this.dialog.open) return;
        this.returnFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal(); this.updateViewer();
        this.querySelector('[data-gallery-close]').focus();
      }
      updateViewer() {
        const selected = this.thumbs[this.index];
        this.imageSize = {width:Number(selected.dataset.width) || 1,height:Number(selected.dataset.height) || 1};
        this.large.src = selected.dataset.large; this.large.alt = selected.dataset.alt;
        this.querySelector('[data-gallery-count]').textContent = `${this.index + 1} / ${this.thumbs.length}`;
        this.querySelector('[data-gallery-prev]').disabled = this.thumbs.length < 2;
        this.querySelector('[data-gallery-next]').disabled = this.thumbs.length < 2;
        this.setZoom(1);
      }
      setZoom(value) {
        const next = Math.max(1, Math.min(4, value));
        const centerX = (this.viewport.scrollLeft + this.viewport.clientWidth / 2) / (this.canvas.offsetWidth || 1);
        const centerY = (this.viewport.scrollTop + this.viewport.clientHeight / 2) / (this.canvas.offsetHeight || 1);
        this.zoom = next;
        const availableWidth = Math.max(1, this.viewport.clientWidth - 40);
        const availableHeight = Math.max(1, this.viewport.clientHeight - 40);
        const size = this.imageSize || {width:1,height:1};
        const fit = Math.min(availableWidth / size.width, availableHeight / size.height);
        const imageWidth = size.width * fit * next;
        const imageHeight = size.height * fit * next;
        this.large.style.width = `${imageWidth}px`;
        this.large.style.height = `${imageHeight}px`;
        this.canvas.style.width = `${Math.max(this.viewport.clientWidth, imageWidth + 40)}px`;
        this.canvas.style.height = `${Math.max(this.viewport.clientHeight, imageHeight + 40)}px`;
        this.viewport.dataset.zoomed = String(next > 1);
        this.viewport.scrollLeft = next === 1 ? 0 : centerX * this.canvas.offsetWidth - this.viewport.clientWidth / 2;
        this.viewport.scrollTop = next === 1 ? 0 : centerY * this.canvas.offsetHeight - this.viewport.clientHeight / 2;
        this.querySelector('[data-gallery-out]').disabled = next === 1;
        this.querySelector('[data-gallery-in]').disabled = next === 4;
      }
      restore() {
        if (this.previousOverflow !== undefined) { document.documentElement.style.overflow = this.previousOverflow; this.previousOverflow = undefined; }
        if (this.returnFocus?.isConnected) this.returnFocus.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
